import TabOptionsGroup from './TabOptionsGroup';

export default TabOptionsGroup;
